import api from 'api'
import type { TimeClock } from './listTimeClocks'

export type CreateTimeClockParams = {
  vendorClockId: string
  companyId: number
  locationId: number
  manufacturer: string
  model: string
}

export async function createTimeClock(
  body: CreateTimeClockParams
): Promise<TimeClock> {
  const result = await api.post<TimeClock>('/admin/time_clock', body)
  return result.data
}
